"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineSchema = exports.validateSchema = exports.fixAndMergeSchema = exports.default = exports.JSchema = void 0;
var JSchema_1 = require("./JSchema");
Object.defineProperty(exports, "JSchema", { enumerable: true, get: function () { return JSchema_1.JSchema; } });
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return JSchema_1.JSchema; } });
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
Object.defineProperty(exports, "fixAndMergeSchema", { enumerable: true, get: function () { return fixAndMergeSchema_1.fixAndMergeSchema; } });
var validateSchema_1 = require("./validateSchema");
Object.defineProperty(exports, "validateSchema", { enumerable: true, get: function () { return validateSchema_1.validateSchema; } });
var defineSchema_1 = require("./defineSchema");
Object.defineProperty(exports, "defineSchema", { enumerable: true, get: function () { return defineSchema_1.defineSchema; } });
//# sourceMappingURL=index.js.map